import * as YupBase from 'yup';
export const Yup = YupBase;
